import React from 'react';
import { Chip, type ChipProps } from '@mui/material';
import {
  getOperationalStatusColor,
  getPriorityColor,
  statusChipSx,
} from '../constants/status-colors';

export type StatusChipKind = 'status' | 'priority';

export interface StatusChipProps extends Omit<ChipProps, 'color' | 'variant'> {
  /** Raw status or priority value — colour is resolved automatically. */
  value: string;
  kind?: StatusChipKind;
  /** Override auto-resolved colour (hex). */
  color?: string;
  chipSize?: 'sm' | 'md';
}

/**
 * Status / priority chip with fixed platform colours and soft tint styling.
 */
const StatusChip: React.FC<StatusChipProps> = ({
  value,
  kind = 'status',
  color,
  chipSize = 'md',
  label,
  sx,
  size = 'small',
  ...rest
}) => {
  const resolved =
    color ??
    (kind === 'priority' ? getPriorityColor(value) : getOperationalStatusColor(value));

  return (
    <Chip
      size={size}
      label={label ?? value}
      sx={[statusChipSx(resolved, chipSize), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...rest}
    />
  );
};

export default StatusChip;
